<div class="container-fluid">
    <app-gene-table-selector [showGenomic] = false [showAssembly] = false [showRepseq]=true></app-gene-table-selector>
    <app-rep-explore-data-panel></app-rep-explore-data-panel>
</div>
